import React, { useState, useCallback, useEffect } from 'react'
import { useField, useFormikContext } from 'formik'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { fetchPhoneCodes } from '../../../../utils/global-fetchs'
import AreaPicker from '../area-picker'


export default ({ label, instantValidate, ...props }) => {
    useStyles(classes)
    const { areaCode, setAreaCode } = props;
    const [field, meta, helpers] = useField(props)
    const { values, setFieldValue } = useFormikContext()
    const [filled, setFilled] = useState(!!field?.value)
    const [focused, setFocused] = useState(false)
    const [codes, setCodes] = useState(null)
    const [code, setCode] = useState(null)

    useEffect(async () => {
        const cds = await fetchPhoneCodes()
        setCodes(cds)
    }, [])

    useEffect(() => {
        setCode(codes?.find?.(c => c.country === values.country))
    }, [codes, values.country])

    useEffect(() => {
        setFilled((!!field?.value || field?.value == 0) || focused)
    }, [field.value, focused])

    const focusHandle = useCallback(e => {
        setFocused(true)
    }, [])

    const blurHandle = useCallback(e => {
        field.onBlur(e)
        setFocused(false)
        if (props.onBlur) {
            Promise.resolve().then(() => {
                props.onBlur(e)
            })
        }
    }, [])

    useEffect(() => {
        if (instantValidate) {
            helpers.setTouched(true, true)
        }
    }, [instantValidate])

    return <div className={`${classes.Container} ${meta.touched && meta.error ? classes.Errored: ''}`}>
        <label className={`${filled? classes.Focused: ''}`}>
            {label}
        </label>
        <div className={`${classes.InputWrapper} ${focused? classes.Focused: ''}`}>
            {
                filled && code && <React.Fragment>
                    {
                        values.country === "PR" ? <React.Fragment>
                            <AreaPicker 
                                areaCode={areaCode || values.phoneArea || code.areaCode}
                                country={code.country}
                                areaCodes={["1787", "1939"]} 
                                setCode={(areaCode) =>{
                                    setAreaCode(areaCode);
                                }} 
                            />
                        </React.Fragment> : <span className={classes.Code}>{code.country}&nbsp;+&nbsp;{code.areaCode}</span>
                    }
                </React.Fragment>
            }
            <input className={classes.Input} {...field} {...props} type='number' onFocus={focusHandle} onBlur={blurHandle}/>
        </div>
        {meta.touched && meta.error && <div className={classes.Error}>{meta.error}</div>}
    </div>
}